import React from "react";
import { Row, Col } from "antd";
import { Container, Title } from "./style";

const UserInformation = ({ employee_information }) => {
	const pin = employee_information && employee_information.pin ? `#${employee_information.pin}` : "-";
	const attr = employee_information ?
		Object.keys(employee_information)
			.map(value => { return { attr: value, value: employee_information[value] }; })
			.filter(value => value.attr != "pin") : [];
	return (
		<Container>
			<Title style={{ marginBottom: 10 }}>User information</Title>
			<Row type="flex" justify="space-between" style={{ marginBottom: 10 }}>
				<Col span={12}>PIN:</Col>
				<Col span={12} style={{ textAlign: "right" }}>{pin}</Col>
			</Row>
			{
				attr.map((value, index) =>
					<Row key={index} type="flex" justify="space-between" style={{ marginBottom: 10 }}>
						<Col span={12}>{`${value.attr}:`}</Col>
						<Col span={12} style={{ textAlign: "right" }}>{value.value || "-"}</Col>
					</Row>)
			}
		</Container>
	);
};

export default UserInformation;


// WEBPACK FOOTER //
// ./src/components/report/individual_user/UserInformation.js